import { Rubric, RubricState } from "../types";

const RUBRIC_KEYS: Array<keyof Omit<RubricState, "rubric_id" | "coverage_id">> = [
  "premise",
  "plot",
  "production_value",
  "characters",
  "setting",
  "structure",
  "casting_potential",
];

export const getRubricAverage = (rubric?: RubricState): number | null => {
  if (!rubric) {
    return null;
  }

  const values = RUBRIC_KEYS.map((key) => rubric[key]).filter(
    (value): value is Rubric => typeof value === "number" && value > 0
  );

  if (values.length === 0) {
    return null;
  }

  return values.reduce((sum, value) => sum + value, 0) / values.length;
};

export const getRubricScores = (
  rubric?: RubricState
): Array<{ key: keyof RubricState; value: Rubric }> => {
  if (!rubric) {
    return [];
  }

  return RUBRIC_KEYS.flatMap((key) => {
    const value = rubric[key];
    if (typeof value !== "number" || value <= 0) {
      return [];
    }
    return [{ key, value }];
  });
};
